import { Route, Switch } from 'react-router-dom';

import EsbLandingPage from '../../components/esb';
import PageNotFound from '../../components/page-not-found';

const EsbContainer = () => (
  <Switch>
    <Route path={['/start/:partnerId', '/start-trial/:partnerId']} component={EsbLandingPage} />
    <Route component={PageNotFound} />
  </Switch>
);

export default EsbContainer;
